import React from 'react';
import { Stack, Tooltip, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

interface MetricHeadingProps {
    children: React.ReactNode;
    /** One-line explanation of how the metric is calculated, shown on hover over the info icon. */
    info?: string;
}

/** Small uppercase heading above a metric, with an optional "how is this calculated" hint. */
const MetricHeading: React.FC<MetricHeadingProps> = ({ children, info }) => (
    <Stack direction="row" spacing={0.5} alignItems="center">
        <Typography sx={{ fontSize: 11, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'text.secondary', fontWeight: 600 }}>
            {children}
        </Typography>
        {info && (
            <Tooltip title={info} arrow placement="top">
                <InfoOutlined sx={{ fontSize: 14, color: 'text.disabled', cursor: 'help' }} />
            </Tooltip>
        )}
    </Stack>
);

export default MetricHeading;
